/*************************************************/
/* 3rd Party                                     */
/*************************************************/
window.$ = window.jQuery = require("jquery");
require("@fancyapps/fancybox");

if (typeof window.document.documentMode == 'undefined') {
    // Passive event listeners
    window.$.event.special.touchstart = {
        setup: function (_, ns, handle) {
            this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
        }
    };
    window.$.event.special.touchmove = {
        setup: function (_, ns, handle) {
            this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
        }
    };
}

import { ieFixes } from "./tooling/ie-fixes.js";
import { mmenu } from "./partials/mmenu.js";
import { inview } from "./partials/inview.js";


/*************************************************/
/* Partials                                      */
/*************************************************/

import { header } from "./partials/header.js";
import { searchbar } from "./partials/searchbar.js";
import { video } from "./partials/video.js";
import { slider } from "./partials/slider.js";
import { brochurePdf } from "./partials/brochurePdf.js";
import { gallery } from "./partials/gallery.js";
import { cookies } from "./partials/cookies.js";

/*************************************************/
/* Init                                          */
/*************************************************/
const ready = callback => {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
}

ready(() => {
    const $body = $("body");

    ieFixes();
    mmenu();
    inview();
    header($body[0]);
    searchbar($body[0]);
    cookies();
    video();
    slider();
    brochurePdf($body);
    gallery();




    //Fire dataLayer event for forms submission
    const formSubmitMessage = document.querySelector('[class^="umbraco-forms-submitmessage"]');
    if (formSubmitMessage) {
        window.dataLayer.push({
            'event': 'formSubmission',
            'formType': formSubmitMessage.dataset.formName
        });
    }

    //Handle scroll to submitted form element
    const formSubmittedElement = document.getElementById("umbraco-forms-form-submitted--clienti");
    if (formSubmittedElement) {
        const headerHeight = document.getElementsByClassName('header')[0].offsetHeight;
     
        window.scrollTo(0, formSubmittedElement.closest('.form-item').offsetTop - headerHeight);
    }

    //Add click listener to skip link
    document.querySelector('#skipLink').addEventListener('click',e => {
        document.querySelector('#mainContent').focus();
    });
});